import React, { Component } from 'react'
import wx from 'weixin-js-sdk'
class OpenDoor extends Component {
    componentDidMount() {
        console.log('.....componentDidMount....', window.location)
        // this.setState({
        //     history: window.location
        // })
        // alert(JSON.stringify(window.location))
        const openId = window.location.href.split('openId=')[1]
        wx.miniProgram.getEnv((res) => {

            console.log(res, '.....wx.miniProgram.getEnv....')
            this.setState({
                res: 1,
            })
            // if (res.miniprogram) {
            //     wx.miniProgram.navigateTo({
            //         url: '/pages/message/customerService' //如果需要传递参数的话可以通过 url 路径拼接
            //     });
            //     return;
            // } else {
            //     console.log('不在小程序中');
            //     return;
            // }
        });
        // wx.miniProgram.redirectTo({
        //     url: '/pages/cart/cart?openId=' + openId,
        // })
        wx.miniProgram.navigateBack()
        wx.miniProgram.postMessage({ data: openId })
    }
    render() {
        return (
            <div className="case-container">
                开门中.....
            </div >
        )
    }
}


export default OpenDoor